import ScanTable from "components/ScanTable/ScanTable";

export default ScanTable;
